import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { BidderService } from 'src/app/services/bidder.service';

@Component({
    selector: 'app-bid-history-dialog',
    templateUrl: './bid-history-dialog.component.html',
    styleUrls: ['./bid-history-dialog.component.css'],
    standalone: false
})
export class BidHistoryDialogComponent implements OnInit {

  @Output() closeModal = new EventEmitter<void>();
  productId: number;
  bidderId: number;

  bidhistoryList = [];
  
  constructor(
    private bidderService: BidderService
  ) { }

  ngOnInit(): void {
    this.bidderService.getBidsHistory(this.bidderId, this.productId).subscribe(data => {
      this.bidhistoryList = data;
    });
  }

  closeBidHistoryDialog(){
    this.closeModal.emit();
  }

}
